<mat-toolbar [class.hatched]="devOrLocalhost.getValue() != 'Production'">
  <a class="logo" href="/" matTooltip="Home page"> <img [src]="logoUrl" /> </a>

  <div class="platform-info">
    <div [matTooltip]="versionInfo">{{ version }}</div>
    @if (devOrLocalhost.getValue() !== 'Production') {
      <div
        class="dev-mode-title"
        matTooltip="You are on the development version of the platform. Your data may be deleted at any time."
        matTooltipPosition="below"
      >
        <mat-icon>warning</mat-icon>
        <div class="hidden-small-screen">{{ devOrLocalhost.getValue() }} platform</div>
      </div>
    }
  </div>

  <span class="spacer hidden-small-screen"></span>

  @if (this.currentUrl$() === '/map') {
    <div class="hidden-small-screen">
      <app-search-bar></app-search-bar>
    </div>

    <span class="hidden-small-screen"
      ><button
        matIconButton
        matSuffix
        (click)="recenterMap()"
        aria-label="Recenter map"
        matTooltip="Recenter map"
      >
        <mat-icon>gps_fixed</mat-icon>
      </button></span
    >

    <span class="spacer"></span>
  }
  @if (websiteUrl != '') {
    <a href="{{ websiteUrl }}" target="_blank" class="icon-button-outlined hidden-small-screen">
      <button matIconButton aria-label="Project website" matTooltip="Project website">
        <mat-icon>launch</mat-icon>
      </button>
    </a>
  }

  @if (wikiUrl != '') {
    <a href="{{ wikiUrl }}" target="_blank" class="icon-button-outlined hidden-small-screen">
      <button matIconButton aria-label="Wiki" matTooltip="Wiki">
        <mat-icon>help</mat-icon>
      </button>
    </a>
  }

  @if (this.currentUrl$() === '/map') {
    <span class="hidden-small-screen">
      @if (feedback == 'azure') {
        <a class="icon-button-outlined" (click)="openFeedback()">
          <button matIconButton aria-label="Feedback" matTooltip="Feedback">
            <mat-icon>feedback</mat-icon>
          </button>
        </a>
      } @else if (feedback != '') {
        <a href="{{ feedbackUrl }}" target="_blank" class="icon-button-outlined">
          <button matIconButton aria-label="Wiki" matTooltip="Wiki">
            <mat-icon>feedback</mat-icon>
          </button>
        </a>
      }
    </span>
  }

  @if (showIntegrationButton()) {
    <a
      matMiniFab
      routerLink="/integration"
      matTooltip="Access Integration Platform"
      aria-label="Integration Platform"
      class="button-switch-page"
    >
      <mat-icon>layers</mat-icon>
    </a>
  } @else if (showMapButton()) {
    <a
      matMiniFab
      routerLink="/map"
      matTooltip="Access Map Platform"
      aria-label="Map Platform"
      class="button-switch-page"
    >
      <mat-icon>map</mat-icon>
    </a>
  }

  <div
    [class.isLoggedIn]="isLoggedIn$()"
    [class.isLoggedOut]="!isLoggedIn$()"
    class="user-management"
  >
    @if (!isLoggedIn$()) {
      <div class="hidden-small-screen">
        <button matButton="filled" (click)="login()">
          <mat-icon>person</mat-icon>
          Login
        </button>
      </div>
      <div class="hidden-big-screen">
        <button matMiniFab aria-label="Login" class="hidden-big-screen" (click)="login()">
          <mat-icon>login</mat-icon>
        </button>
      </div>
    } @else {
      <div class="hidden-small-screen">
        <button matButton="filled" (click)="openUserManagement()">
          <mat-icon>person</mat-icon>Account
        </button>
      </div>

      <div class="hidden-big-screen">
        <button
          matMiniFab
          aria-label="Account"
          class="hidden-big-screen"
          (click)="openUserManagement()"
        >
          <mat-icon>person</mat-icon>
        </button>
      </div>
    }
  </div>
</mat-toolbar>
